var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skip-tutorial",on:{"click":function($event){return _vm.$emit('skip-tutorial')}}},[_c('span',{staticClass:"skip-link"},[_vm._v(" Skip tutorial ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }